export const activityLogTableColumns = [
  { title: 'Date', key: 'createdAt', width: 33, keySort: 'date' },
  { title: 'Action Taken', key: 'taskName', width: 33, keySort: 'action taken' },
  { title: 'Action Taken By', key: 'userName', width: 33, keySort: 'action taken by' }
];

export const docusignRoutingTableColumns = [
  { title: 'Routing Order', key: 'routingOrder', width: 20, keySort: 'routingOrder' },
  { title: 'Completed', key: 'completedAt', width: 20, keySort: 'completed' },
  { title: 'Role', key: 'role', width: 20, keySort: 'role' },
  { title: 'Name', key: 'name', width: 20, keySort: 'name' },
  { title: 'Email', key: 'email', width: 20, keySort: 'email' }
];

export const signaturePacketTableColumns = [
  { title: 'Version Date', key: 'versionDate', width: 24, keySort: 'version date' },
  { title: 'Task', key: 'task', width: 24, keySort: 'task' },
  { title: 'Completed By', key: 'completedBy', width: 24, keySort: 'completed by' },
  { title: 'Email', key: 'email', width: 24, keySort: 'email' },
  { title: ' ', key: ' ', width: 5 }
];
